import React from "react";
import { Link } from "react-router-dom";
import "./sidebar.css"; // Make sure to import your CSS file

const Sidebar = ({ isOpen, selectedItem, setSelectedItem }) => {
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
      <ul className="menu-list">
  <li>
    <Link
      to="/content"
      onClick={() => handleItemClick("all")}
      className={`menu-item ${selectedItem === "all" ? "open" : ""}`}
    >
      All
    </Link>
    <ul className={`sub-menu-list ${selectedItem === "all" ? "open" : ""}`}>
      <li>
        <Link
          to="/articles"
          onClick={() => handleItemClick("articles")}
          className={`sub-menu-item ${
            selectedItem === "articles" ? "open" : ""
          }`}
        >
          Articles
        </Link>
      </li>
      <li>
        <Link
          to="/MovieReviews"
          onClick={() => handleItemClick("MovieReviews")}
          className={`sub-menu-item ${
            selectedItem === "MovieReviews" ? "open" : ""
          }`}
        >
          Movie Reviews
        </Link>
      </li>
      <li>
        <Link
          to="/shortStories"
          onClick={() => handleItemClick("shortStories")}
          className={`sub-menu-item ${
            selectedItem === "shortStories" ? "open" : ""
          }`}
        >
          Short Stories
        </Link>
      </li>
    </ul>
  </li>
</ul>

    </div>
  );
};

export default Sidebar;
